import client from "@irati/utils/services/apollo"
import {PaymentSavedCard, PaymentProvider} from "@irati/types"

import getSavedCardsQuery, {savedCardsKey} from "./queries/getSavedCardsQuery"
import deleteSavedCardMutation, {deleteSavedCardKey} from "./mutations/deleteSavedCardMutation"
import paymentProviderForCountryCode from "@irati/payments/helpers/paymentProviderForCountryCode"

interface SavedCardProvider {
  provider?: PaymentProvider
}

class SavedCards {
  async list(savedCardProvider?: SavedCardProvider, {forceRefetch = true} = {}) {
    const fetchPolicy = forceRefetch ? "network-only" : "cache-first"
    const variables = {
      provider: savedCardProvider?.provider || await defaultSavedCardProvider()
    }

    return client.query({query: getSavedCardsQuery, variables, fetchPolicy}).then(({data}) => data[savedCardsKey])
  }

  async delete(card: PaymentSavedCard, savedCardProvider?: SavedCardProvider) {
    const variables = {
      provider: savedCardProvider?.provider || await defaultSavedCardProvider(),
      cardReference: card.reference
    }

    return client.mutate({mutation: deleteSavedCardMutation, variables}).then(({data}) => data[deleteSavedCardKey])
  }
}

const savedCardsService = new SavedCards()

export const getSavedCards = savedCardsService.list
export const deleteSavedCard = savedCardsService.delete

export default savedCardsService

export async function defaultSavedCardProvider(): Promise<PaymentProvider> {
  const provider = await paymentProviderForCountryCode()
  return provider
}
